/* btn search */
$('header .navigation .buttonWrapper .btn-search').click(function () {
    $('header .navigation .searchOverlay, header .navigation .searchOverlayBackground').addClass('searchActive');
    initSearchTernm();
});
$('.btn-closeSearch, .searchOverlayBackground').click(function () {
    $('header .navigation .searchOverlay, header .navigation .searchOverlayBackground').removeClass('searchActive');
});

function initSearchTernm() {

    $('.searchOverlay .searchTerm:visible').focus();
    var autocompleteList =  $('.searchOverlay .searchTerm').attr('data-autocompleteList');
    if(autocompleteList && autocompleteList.length > 0){
        $('.searchOverlay .searchTerm').autocomplete({
            source: autocompleteList.split(','),
            appendTo: ".searchOverlay .searchAutocompleteBox",
            minLength: 3,
            autoFocus: true,
            delay: 300
        });
        $.ui.autocomplete.prototype._renderItem = function (ul, item) {
            item.label = item.label.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + $.ui.autocomplete.escapeRegex(this.term) + ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<b>$1</b>");
            return $("<li></li>").data("item.autocomplete", item).append("<a>" + item.label + "</a>").appendTo(ul);
        };
    }
}

